var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation"},[_c('ul',{staticClass:"customUl"},[_c('li',{on:{"click":function($event){return _vm.setLanguage('de')}}},[_vm._v("Deutsch")]),_c('li',{on:{"click":function($event){return _vm.setLanguage('en')}}},[_vm._v("English")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }